import classes from './SideMenu.module.scss';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';
import {
    CustomizedConfirmDeleteModal,
    CustomizedDropdownMenu,
    CustomizedRoundIcon,
    CustomizedTooltip,
} from 'components/common';
import Icon from 'components/common/Icons/icon';
import { ActionMenuItemWithIcon } from 'components/common/ActionMenuItemWithIcon/actionMenuItemWithIcon';
import React, { useCallback, useState } from 'react';
import { useMutationDeleteCard } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/queries/cardModalMutation';
import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';
import { generatePath, useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import qs from 'qs';
import { useVersionStore } from 'store/version.store';

interface ISideMenuProps {
    title: string;
    taskId: number;
    id: number;
    handleModalClose: () => void;
    deleteCardCallback: () => void;
}

export const SideMenu = ({ title, taskId, id, handleModalClose, deleteCardCallback }: ISideMenuProps) => {
    const [deleteCardModalShow, setDeleteCardModalShow] = useState<boolean>(false);

    const history = useHistory();
    const { path } = useRouteMatch();
    const params = useParams();
    const { search } = useLocation();
    const { handleSnackBar } = useCustomSnackBar();
    const version = useVersionStore((state) => state.version);
    const { mutate: deleteCardMutate, isLoading: deleteCardLoading } = useMutationDeleteCard();

    const handleCardDelete = useCallback(() => {
        setDeleteCardModalShow(false);
        if (id && version) {
            deleteCardMutate(
                { cardId: id, versionId: version.id },
                {
                    onSuccess: () => {
                        handleSnackBar('Card Deleted Successfully', 'success');
                        handleModalClose();
                        deleteCardCallback();
                    },
                    onError: (error) => {
                        DEFAULT_ERROR({ error, handleError: handleSnackBar });
                    },
                },
            );
        }
    }, []);

    const handleCreateUserAction = (taskId: number) => {
        const newSearch = qs.stringify({ ...qs.parse(search), taskId: taskId });
        const pathname = generatePath(path, { ...params, cardId: 'newCard' });
        setTimeout(() => {
            history.push({
                pathname,
                search: newSearch,
            });
        }, 0);
    };

    return (
        <div className={classes.sideMenuContainer}>
            <ShareInsightButton title={`activity "${title}"`} link={window.location.href.split('?')[0]} size={'3rem'} />

            <CustomizedDropdownMenu
                triggerElement={
                    <CustomizedTooltip
                        tooltipContent={`Manage Activity`}
                        triggerElement={
                            <CustomizedRoundIcon size={'3rem'}>
                                <Icon name={'three-dot-icon'} />
                            </CustomizedRoundIcon>
                        }
                    />
                }
            >
                {taskId && (
                    <ActionMenuItemWithIcon
                        handleClick={() => {
                            handleCreateUserAction(taskId);
                        }}
                        iconText={'Add Associated User Action'}
                        iconType={'plus-icon'}
                        iconSize={'1.3rem'}
                    />
                )}

                <ActionMenuItemWithIcon
                    handleClick={() => {
                        setDeleteCardModalShow(true);
                    }}
                    iconText={'Delete'}
                    iconType={'delete-icon'}
                    iconSize={'1.6rem'}
                />
            </CustomizedDropdownMenu>

            <CustomizedConfirmDeleteModal
                isShowModal={deleteCardModalShow}
                hideModal={() => {
                    setDeleteCardModalShow(false);
                }}
                text={'Are you sure you want to delete this Card?'}
                onConfirm={handleCardDelete}
                isLoading={deleteCardLoading}
            />
        </div>
    );
};
